import { RpcRequest } from '@message-bus/core';
import {NativeNamespaces, SystemNativeMethods} from '@mobile-data-access-enums';

@RpcRequest(NativeNamespaces.SYSTEM, SystemNativeMethods.GO_TO_APP_SETTINGS_PAGE)
export class GoToAppSettingPageNativeMethod {}
